module.exports = __webpack_public_path__ + "img/MiniLinda.07370b98.png";